import {FullscreenLayer} from '@volkswagen-onehub/components-core';
import React, {FC, ReactNode} from 'react';
import Div from '../components/Div.styled';
import GradientMeshBackground from '../components/GradientMeshBackground';
import useMediaQuery from '../hooks/useMediaQuery';

interface Props {
  children: ReactNode;
}

const QuestionContainer: FC<Props> = (props) => {
  const {children} = props;
  const {isMobile} = useMediaQuery();
  return (
    <Div
      customStyles={{zIndex: 10, position: 'relative'}}
      id="question-container"
    >
      <FullscreenLayer active>
        <Div
          customStyles={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
          padding={isMobile ? '104px 0px 0' : '125px 0px 0'}
        >
          <GradientMeshBackground />
          {children}
        </Div>
      </FullscreenLayer>
    </Div>
  );
};
export default QuestionContainer;
